import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const SalesTeamService = {
  getAll: async () => {
    const res = await axios.get(ENDPOINT.SalesTeams);
    return res.data;
  },
  getById: async (id) => {
    const res = await axios.get(`${ENDPOINT.SalesTeams}/${id}`);
    return res.data;
  },
  create: async (data) => {
    const res = await axios.post(ENDPOINT.SalesTeams, data);
    return res.data;
  },
  update: async (id, data) => {
    const res = await axios.put(`${ENDPOINT.SalesTeams}/${id}`, data);
    return res.data;
  },
  remove: async (id) => {
    const res = await axios.delete(`${ENDPOINT.SalesTeams}/${id}`);
    return res.data;
  },
};